/**
 * Created by andrey on 02.07.2021.
 */

const UnitAdditionalView = cc.Node.extend({
    ctor: function (unitView, view, type) {
        this._super();

        this.unitView = unitView;
        this.view = view;
        this.type = type;

        this.setCascadeOpacityEnabledRecursively(true);

        this.setBasePosition();

        this.view.runAnimation && this.view.runAnimation();
    },

    setBasePosition: function () {
        const viewAlignmentComponent = ComponentMap.get(this.view, AlignmentComponent);
        this.setAlignment(viewAlignmentComponent ? viewAlignmentComponent.alignment : this.view.getPosition());

        this.view.setAlignment(0, 0);
        this.addChild(this.view);

        this.unitView.addChild(this);
        ComponentMap.detach(this, AlignmentComponent);

        this.basePosition = this.getPosition();
    },

    animateAppear: function (initialSize) {
        if (cleverapps.silentIntro) {
            return;
        }

        this.stopAllActions();

        const actions = [];

        if (this.type === "customerMark") {
            actions.push(
                StandartAnimations.showUp(this.view, {
                    customSqueeze: true,
                    move: cleverapps.styles.UnitAdditionalView.customerMark.showUp
                })
            );
        } else if (typeof FeedableInfoView !== "undefined" && this.view instanceof FeedableInfoView) {
            actions.push(
                StandartAnimations.showUp(this.view, {
                    customSqueeze: true,
                    move: cleverapps.styles.UnitAdditionalView.feedableInfo.showUp
                })
            );
        } else if (initialSize) {
            const scaleX = initialSize.width / this.view.width;
            const scaleY = initialSize.height / this.view.height;
            const scale = Math.min(scaleX, scaleY);

            const units = [];
            const collectUnits = (node) => {
                node.getChildren().forEach((child) => {
                    if (typeof CustomerIngredientView !== "undefined" && child instanceof CustomerIngredientView) {
                        units.push(child);
                    } else {
                        collectUnits(child);
                    }
                });
            };
            collectUnits(this.view);

            this.setScale(scaleX, scaleY);

            this.view.getChildren().filter((child) => child !== this.view.background).forEach((node) => {
                const baseX = node.scaleX;
                const baseY = node.scaleY;
                node.setScale(baseX * scale / scaleX, baseY * scale / scaleY);
                node.runAction(new cc.ScaleTo(0.3, baseX, baseY).easing(cc.easeBackOut(1)));
            });

            units.forEach((node) => {
                const baseX = node.scaleX;
                const baseY = node.scaleY;
                node.setScale(baseX / scale, baseY / scale);
                node.runAction(new cc.ScaleTo(0.3, baseX, baseY).easing(cc.easeBackOut(1)));
            });

            actions.push(new cc.Show());
            actions.push(new cc.ScaleTo(0.3, 1, 1).easing(cc.easeBackOut(1)));
        } else {
            this.setScale(0.5);
            actions.push(new cc.Show());
            actions.push(new cc.ScaleTo(0.2, 1, 1).easing(cc.easeIn(1)));
        }

        if (this.view.runAnimation) {
            actions.push(new cc.CallFunc(() => {
                this.view.setAlignment(0, 0);
                this.view.runAnimation();
            }));
        }

        this.setVisible(false);
        this.runAction(actions.length === 1 ? actions[0] : new cc.Sequence(actions));
    },

    hide: function () {
        this.stopAllActions();
        this.setVisible(false);
    },

    animateHide: function (callback) {
        this.stopAllActions();

        const actions = [
            new cc.ScaleTo(0.05, 0.5, 0.5).easing(cc.easeIn(1)),
            new cc.Hide()
        ];
        if (callback) {
            actions.push(new cc.CallFunc(callback));
        }
        this.runAction(new cc.Sequence(actions));
    },

    remove: function (silent) {
        if (!silent) {
            this.animateHide(() => {
                this.removeFromParent();
            });
        } else {
            this.removeFromParent();
        }
        if (this.view.beforeRemove) {
            this.view.beforeRemove();
        }
    }
});

cleverapps.styles.UnitAdditionalView = {
    customerMark: {
        showUp: { x: -40, y: 0 }
    },

    feedableInfo: {
        showUp: { x: 120, y: -60 }
    }
};